<template>
  <v-row>
    <v-col v-for="card in cardsMetrics" :key="card.title" cols="6" sm="4" md="3">
      <cbm-card :number-text="card.number" :title="card.title" :tooltip="card.tooltipText" :boolean-loader="loading" simple-card />
    </v-col>
  </v-row>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import { QUERY_GET_APP_METRICS } from '../../graphql'
import { mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  components: {
    CbmCard: () => import('@/components/CbmCard.vue'),
  },
  data: () => ({
    loading: false,
    appMetrics: Object.fromEntries(
      ['total_count', 'client_active_count', 'client_recent_inactive_count', 'client_at_risk_count', 'client_never_bought_count'].map((key) => [key, 0])
    ),
  }),
  computed: {
    ...mapState({
      lastUpdate: (state) => state.lastUpdate,
    }),
    lastUpdateFormatted() {
      if (!this.lastUpdate?.last_updated) return 'Data Indisponível'
      return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('dd/MM/yyyy')
    },
    cardsMetrics() {
      const lastUpdateFormatted = this.lastUpdateFormatted
      const { total_count, client_active_count, client_recent_inactive_count, client_at_risk_count, client_never_bought_count } = this.appMetrics

      return [
        {
          title: 'Clientes com aplicativo',
          number: localeString(total_count),
          tooltipText: `Clientes atingíveis por push até essa data: ${lastUpdateFormatted}`,
        },
        {
          title: 'Clientes ativos',
          number: localeString(client_active_count),
          tooltipText: `Clientes com o app ativos até essa data: ${lastUpdateFormatted}`,
        },
        {
          title: 'Clientes inativos',
          number: localeString((client_at_risk_count || 0) + (client_recent_inactive_count || 0)),
          tooltipText: `Total de clientes inativos recentes e em risco com o app até essa data: ${lastUpdateFormatted}`,
        },
        {
          title: 'Clientes sem cupons',
          number: localeString(client_never_bought_count),
          tooltipText: `Clientes que nunca compraram até essa data: ${lastUpdateFormatted}`,
        },
      ]
    },
  },
  mounted() {
    this.getAppMetricsData()
  },
  methods: {
    async getAppMetricsData() {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          query: QUERY_GET_APP_METRICS,
        })
        this.appMetrics = data.getAggregatedClientStatusInfo?.push || {}
      } catch (error) {
        console.error('Erro ao buscar métricas:', error.message || error)
        this.$snackbar({ message: 'Erro ao buscar métricas do aplicativo' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
